<template lang="pug">
  div.row(style="overflow:hidden")
    div(ref='canvas' style="height:300px;width:600px")
</template>
<script>
// Generated by CoffeeScript 2.3.0

export default {
  name: 'Pie',
  chart: null,
  props: {
    opts: Object,
  },
  data() {
    return {
      nTotal: 0,
      nEmpty: 0,
    }
  },
  mounted() {
    return this.render()
  },
  methods: {
    load() {
      return this.opts.load().then(data => {
        this.nTotal = data.length
        data = data.sort((a, b) => b.y - a.y)
        data.map((d, k) => {
          if (d._id === '') {
            d._id = '空'
          }
          return (d.label = d.name = `${k + 1}-${d._id}`)
        })
        return (data = data.slice(0, 30))
      })
    },
    explode(e) {
      if (
        typeof e.dataSeries.dataPoints[e.dataPointIndex].exploded === 'undefined' ||
        !e.dataSeries.dataPoints[e.dataPointIndex].exploded
      ) {
        e.dataSeries.dataPoints[e.dataPointIndex].exploded = true
      } else {
        e.dataSeries.dataPoints[e.dataPointIndex].exploded = false
      }
      return e.chart.render()
    },
    clickOnNull() {
      if (this.opts.clickOnNull) {
        return this.opts.clickOnNull()
      }
    },
    click(e) {
      if (this.opts.click) {
        return this.opts.click(e.dataSeries.dataPoints[e.dataPointIndex].label.replace(/\d+-/, ''))
      } else {
        return this.explode
      }
    },
    render() {
      return this.load().then(data => {
        if (!window.CanvasJS) {
          require('../../../../public/canvasjs')
        }
        this.chart = new CanvasJS.Chart(this.$refs.canvas, {
          title: {
            text: `${this.opts.title} （共${this.nTotal}项）`,
          },

          // legend:
          //   cursor: "pointer"
          //   itemclick: @click
          explodeOnClick: false,
          exportEnabled: true,
          data: [
            {
              type: 'pie',
              startAngle: 240,
              toolTipContent: '{name}: <strong>{y}</strong> （点击进行筛选）',
              // showInLegend: true
              explodeOnClick: false,
              click: e => this.click(e),
              yValueFormatString: '##0',
              indexLabel: '{label} ({y})',
              dataPoints: data,
            },
          ],
        })
        return this.chart.render()
      })
    },
  },
}
</script>
